<script setup lang="ts">
import notPermission from '@/assets/images/not_permission.png';
</script>

<template>
    <div class="flex flex-col justify-center items-center flex-1 h-screen">
        <img :src="notPermission" alt="notPermission" />
        <div class="flex flex-col justify-center items-center max-w-[800px] font-semibold">
            <p class="text-3xl text-gray-900 leading-9 mb-2 text-center">We’re currently performing scheduled maintenance.</p>
            <p class="text-base text-gray-600 leading-6 font-normal text-center">
                Our website is temporarily unavailable while we improve your experience.We’ll be back shortly — thank you for your patience!
            </p>
        </div>
    </div>
</template>
